export default __webpack_public_path__ + "static/media/andes_a_la_selva_5.3216a5f3.JPG";